import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import Select from "react-select";

export default class EssenceReferenceCisternEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      pending: false,
      ship: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = async () => {
    this.setState({ pending: true });
    const editData = this.props.data;

    let ship = [];
    let shipQuery = await this.context.api.qa("/ship/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(shipQuery)) {
      shipQuery.forEach((item) => {
        ship.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    this.setState(
      {
        editData,
        pending: false,
        ship,
      },
      () => this.triggerChange()
    );
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      this.props.onChange({
        maxvolume: this.state.editData.maxvolume || null,
        ship: this.state.editData.ship || null,
      });
    }
  };

  render() {
    const editData = this.state.editData || {};

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="form-group">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Максимальный объем:</label>
                  <input
                    onChange={(e) => this.onChange("maxvolume", e.target.value)}
                    className="form-control"
                    value={editData.maxvolume || ""}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Судно:</label>
                  <Select
                    value={this.context.api.getReferenceValue(
                      editData.ship,
                      this.state.ship
                    )}
                    onChange={(result) => this.onChange("ship", result.value)}
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.ship}
                    placeholder="Выберите судно..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
